import { nativeAudioService } from '../services/nativeAudioService';

// Test audio service
export async function testAudioPlayback() {
  try {
    console.log('Testing audio service...');
    
    // Initialize service
    await nativeAudioService.initialize();
    console.log('Audio service initialized. Is native:', nativeAudioService.isNative());
    
    // Test with a sample audio URL
    const testAudioUrl = 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3';
    const assetId = 'test-audio';
    
    console.log('Preloading audio...');
    await nativeAudioService.preloadAudio(assetId, testAudioUrl, true);
    console.log('Audio preloaded successfully');
    
    console.log('Playing audio...');
    await nativeAudioService.play(assetId);
    
    // Play for 5 seconds
    setTimeout(async () => {
      console.log('Pausing audio...');
      await nativeAudioService.pause(assetId);
      
      // Resume after 2 seconds
      setTimeout(async () => {
        console.log('Resuming audio...');
        await nativeAudioService.resume(assetId);
        
        // Stop after 3 more seconds
        setTimeout(async () => {
          console.log('Stopping audio...');
          await nativeAudioService.stop(assetId);
          
          console.log('Unloading audio...');
          await nativeAudioService.unload(assetId);
          
          console.log('Audio test completed successfully!');
        }, 3000);
      }, 2000);
    }, 5000);
    
  } catch (error) {
    console.error('Audio test failed:', error);
  }
}

// Add to window for easy testing in console
if (typeof window !== 'undefined') {
  (window as any).testAudioPlayback = testAudioPlayback;
}